import { c as _c } from "react/compiler-runtime";
import { useTranslation } from 'react-i18next';
import type { ChildAvailabilityItem, ChildDetails } from '@sola/schema/dotcom/children/child.ts';
import { ChildGenderEnum } from '@sola/schema/dotcom/children/childUtilityInterfaces.ts';
import { getFamilyList, listFormat } from '@sola/shared-utils/children/bio.ts';
import { getAgeFromBirthday } from '@sola/shared-utils/children/utils.ts';
type ChildGenderKey = 'girl' | 'boy';
const getChildGenderKey = (gender: ChildGenderEnum | null | undefined): ChildGenderKey => gender === ChildGenderEnum.Female ? 'girl' : 'boy';
const getChildName = (child: ChildDetails) => child.name.preferred || child.name.first;
interface SpotlightCardSubData {
  childImageUrl?: string | null;
  childName: string;
  age: number;
  genderContext: ChildGenderEnum;
  genderKey: 'girl' | 'boy';
  country: string;
  family: string;
  favoriteActivities: string;
  waitingDays?: number;
  previousChildName: string;
  birthDate: string;
}
export const useDepartureSubSpotlightCard = t0 => {
  const $ = _c(27);
  const {
    availability,
    childDetails,
    departingChildDetails
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["my", "bio"];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation(t1);
  let t2;
  if ($[1] !== departingChildDetails || $[2] !== t) {
    t2 = getChildName(departingChildDetails) || t("my:sponsorshipRelationship.departures.spotlight.sub.previousChildFallback");
    $[1] = departingChildDetails;
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const previousChildName = t2;
  let t3;
  if ($[4] !== childDetails.birthDate) {
    t3 = getAgeFromBirthday(childDetails.birthDate);
    $[4] = childDetails.birthDate;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const fallbackAge = t3;
  const age = availability.age ?? (typeof fallbackAge === "number" ? fallbackAge : undefined);
  let t4;
  if ($[6] !== childDetails.gender) {
    t4 = getChildGenderKey(childDetails.gender);
    $[6] = childDetails.gender;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const genderKey = t4;
  const t5 = childDetails.householdList[0]?.householdMemberList;
  let t6;
  if ($[8] !== t || $[9] !== t5) {
    t6 = getFamilyList(t, t5);
    $[8] = t;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  const family = t6;
  let t7;
  if ($[11] !== childDetails.gender || $[12] !== childDetails.interests.thingsILike || $[13] !== t) {
    t7 = childDetails.interests.thingsILike.length > 0 ? t("bio:favoriteActivities", {
      context: childDetails.gender,
      favorites: listFormat(t, childDetails.interests.thingsILike.slice(0, 3))
    }) : "";
    $[11] = childDetails.gender;
    $[12] = childDetails.interests.thingsILike;
    $[13] = t;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  const favoriteActivities = t7;
  let t8;
  if ($[15] !== age || $[16] !== availability.icp || $[17] !== availability.minDaysWaiting || $[18] !== childDetails || $[19] !== family || $[20] !== favoriteActivities || $[21] !== genderKey || $[22] !== previousChildName) {
    t8 = age === undefined ? undefined : {
      childImageUrl: childDetails.imageUrl,
      childName: getChildName(childDetails),
      age,
      genderKey,
      genderContext: childDetails.gender,
      country: childDetails.country || availability.icp.country || "",
      family,
      favoriteActivities,
      waitingDays: availability.minDaysWaiting ?? undefined,
      previousChildName,
      birthDate: childDetails.birthDate
    };
    $[15] = age;
    $[16] = availability.icp;
    $[17] = availability.minDaysWaiting;
    $[18] = childDetails;
    $[19] = family;
    $[20] = favoriteActivities;
    $[21] = genderKey;
    $[22] = previousChildName;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  const cardData = t8;
  let t9;
  if ($[24] !== cardData || $[25] !== t) {
    t9 = {
      t,
      cardData
    };
    $[24] = cardData;
    $[25] = t;
    $[26] = t9;
  } else {
    t9 = $[26];
  }
  return t9;
};